<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
<div class="flex flex-column md:flex-row align-items-center justify-content-end gap-1">
  
  <p-button icon="pi pi-fw pi-search" label="QC Reviews" *ngIf="profile?.type == 4" (onClick)="goToQCReviews()" styleClass="p-button-outlined p-button-sm"></p-button>
  <p-button icon="pi pi-fw pi-search" label="Forwarder Reviews" *ngIf="profile?.type == 5" (onClick)="goToForwarderReviews()" styleClass="p-button-outlined p-button-sm"></p-button>
  <p-button icon="pi pi-fw pi-search" label="Custom Agent Reviews" *ngIf="profile?.type == 6" (onClick)="goToCustomAgentReviews()" styleClass="p-button-outlined p-button-sm"></p-button>

  <div class="flex flex-row align-items-center mr-2">
    <p-button (onClick)="goToUserPanel()"
      styleClass="p-button-rounded p-button-secondary p-button-text" class="icon-button-size"
      pTooltip="{{'HomeHeader.UserMenu.AccountItem' | translate}}" tooltipPosition="bottom">
      <span class="material-symbols-outlined header-icon-color pr-2">
        account_circle
      </span>
      <span class="header-icon-color text-sm">{{ profile?.contactName }}</span>
    </p-button>
  </div>
  
  <p-button (onClick)="notificationsMenuVisible = true"
    styleClass="p-button-rounded p-button-secondary p-button-text" class="icon-button-size"
    pTooltip="{{'HomeHeader.UserMenu.NotificationsToolTip' | translate: {value: notificationBadge} }}" tooltipPosition="bottom">
    <span class="material-symbols-outlined mr-4 header-icon-color" 
      pBadge [value]="notificationBadge" severity="success">
      notifications
    </span>
  </p-button>

  <app-switch-lang [showOnlyIcon]="true" [showClear]="false"></app-switch-lang>
  
  <p-button (onClick)="helpMenu.toggle($event)"
    styleClass="p-button-rounded p-button-secondary p-button-text" class="icon-button-size"
    pTooltip="{{'UserMenuComponent.HelpMenuItems.CustomerHelpLabel' | translate}}" tooltipPosition="bottom">
    <span class="material-symbols-outlined header-icon-color">
      help
    </span>
  </p-button>

  <p-divider layout="vertical"></p-divider>

  <p-button (onClick)="logout()" label="{{'HomeHeader.UserMenu.LogoutToolTip' | translate}}"
    icon="pi pi-fw pi-sign-out" styleClass="p-button-text p-button-primary p-button-sm" class="pr-2">
  </p-button>
</div>

<p-menu #menu [model]="userMenuItems" [popup]="true"></p-menu>
<app-notification-list [isVisible]="notificationsMenuVisible" (onDialogClose)="onDialogClose($event)"/>
<p-menu #helpMenu [model]="helpMenuItems" [popup]="true"></p-menu>